<template>
	<div id="container">

		<header id="header" class="navbar navbar-default navbar-static-top">
			<div class="container">
				<span class="navbar-brand">
					Семейна образователна мрежа <img src="/network/static/img/sun.png" alt="FEN" title="FEN" height="40" />
				</span>
				<a class="pull-right my-1" href="/network/logout"><i class="fa fa-sign-out fa-fw"></i> Изход</a>
			</div>
	</header>

		<!-- Content Wrapper. Contains page content -->
		<div class="content">

			<section class="content-header">
			<div class="container">
				<div class="page-header">
					<h1>{{ $t($route.name) }}</h1>
				</div>
			</div>
			</section>

			<div class="container">
				<router-view></router-view>
			</div>
		</div>
		<!-- /.content-wrapper -->

		<!-- Main Footer -->
		<footer class="main-footer text-center my-1" id="footer">
			<a href="http://www.homeschoolingbg.com" target="_blank">Асоциация за домашно образование</a> &copy; 2017 Всички права запазени. Версия 0.0.1
		</footer>
	</div>
	<!-- ./wrapper -->
</template>

<script>
const $ = require('jquery');
module.exports = {
	name: 'NoSideMenuView',
	data: function () {
		return {
			section: 'Dash',
			me: '',
			error: '',
			api: {
				servers: {
					url: '', // Back end server
					result: []
				}
			}
		};
	},
	computed: {
		state: function () {
			return {
				userInfo: {
					tasks: [],
					messages: [],
					notifications: []
				}
			};
		},
		callAPI: function () {
			return this.$parent.callAPI;
		},
		year: function () {
			var y = new Date();
			return y.getFullYear();
		}
	},
	methods: {
		toggleMenu: function (event) {
			// remove active from li
			$('li.pageLink').removeClass('active');

			// Add it to the item that was clicked
			event.toElement.parentElement.className = 'pageLink active';
		}
	},
	mounted: function () {
		// Page is ready. Let's load our functions!
	}
};
</script>

<style>


</style>



// WEBPACK FOOTER //
// NoSideMenuView.vue?afa91afe